import { useEffect } from "react";
import "./Incubation.css";
import { Backtotop, Floatinmenu, Underline } from "../../widgets";
import { FaComputer } from "react-icons/fa6";
import { incubation_menu, incubation_img_corousal } from "../../constants/incubation";

import { RadialMenu, Listformat, Heroimagecarousal } from "../../components";
import { startup_support_services } from "../../constants/incubation";

const Startup = () => {
  useEffect(() => {
    document.title = 'ACCET-CSE Department';
  }, []);
  return (
    <div className="incubationdept">
      <Heroimagecarousal
        key={incubation_img_corousal.id}
        title={incubation_img_corousal.title}
        img_list={incubation_img_corousal.img_list}
      />
      <section className="incubationdark">
        <div className="dept_float_menu">
          <Floatinmenu logo={FaComputer} head="Menu" links={incubation_menu} />
        </div>
        <RadialMenu menu_links={incubation_menu} />
        <div className="incubation_support_services">
          <Underline heading="Startup Support Services" />
          <Listformat points={startup_support_services} />
        </div>
      </section>

      <Backtotop />
    </div>
  );
};

export default Startup;
